import * as Yup from "yup";

import { isBlank } from "utils/storeUtils";
import { SCHEDULED_FOR_MAILING } from "enums";
import { getTomorrow, formatDateToUTC } from "utils/dateTimeUtils";

export const LIMIT_EMAIL_SHARE = 25;

export const initialValues = (ownerName, scheduledForMailing = SCHEDULED_FOR_MAILING.now, scheduledAt) => ({
  ownerName,
  recipients: "",
  scheduledForMailing,
  scheduledAt: scheduledForMailing === SCHEDULED_FOR_MAILING.now ? getTomorrow() : scheduledAt,
});

export const validationSchema = Yup.object().shape({
  ownerName: Yup.string()
    .trim()
    .required("Owner name is a required field"),
  recipients: Yup.string()
    .test("validEmails", "Oops! One of the email addresses isn't valid", (value) => {
      if (isBlank(value)) {
        return true;
      }

      const emails = value.split(/[\s,]+/).filter(Boolean);
      return emails.every((email) => /^.+@.+\..+$/.test(email));
    })
    .required("Recipients is a required field")
    .test(
      "limitEmailShare",
      `Oops! We're only able to send up to ${LIMIT_EMAIL_SHARE} emails at a time, please update your list to ${LIMIT_EMAIL_SHARE} or less.`,
      (value) => {
        if (isBlank(value)) {
          return true;
        }

        const emails = value.split(/[\s,]+/).filter(Boolean);
        return emails.length <= LIMIT_EMAIL_SHARE;
      },
    ),
  scheduledForMailing: Yup.string(),
  scheduledAt: Yup.date().when("scheduledForMailing", {
    is: (value) => value === SCHEDULED_FOR_MAILING.later,
    then: Yup.date().min(getTomorrow(), "You must select a future date"),
  }),
});

export const attributesToSubmit = (values, make) => {
  const { ownerName, scheduledForMailing, scheduledAt, recipients } = values;
  const { id } = make;

  const emails = recipients
    .trim()
    .replace(/,*$/, "")
    .split(/[\s,]+/);

  return {
    data: {
      attributes: {
        "owner-name": ownerName,
        "scheduled-at": scheduledForMailing === SCHEDULED_FOR_MAILING.later ? formatDateToUTC(scheduledAt) : null,
      },
      relationships: {
        make: {
          data: {
            type: "makes",
            id,
          },
        },
        recipients: {
          data: emails.map((email) => {
            return {
              attributes: {
                email,
              },
              type: "recipients",
            };
          }),
        },
      },
      type: "shares",
    },
  };
};
